export default "__VITE_ASSET__Gg7692lY__"